/* eslint-disable react/prop-types */
import {useContext, useEffect, useState} from 'react'

import SUIContext from '@s-ui/react-context'
import useMediaQuery from '@s-ui/react-hooks/lib/useMediaQuery'
import useMount from '@s-ui/react-hooks/lib/useMount'
import useOnScreen from '@s-ui/react-hooks/lib/useOnScreen'
import {useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import ListRelatedAds, {listRelatedAdsDisplay} from '@adv-mt/mt-list-related-ads'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

// Slides shown for each column count the ListAds grid renders, so the carousel stays in step with
// the grid it is injected into.
const SLIDES_BY_GRID_COLUMNS = {4: 5, 3: 4, 2: 4, 1: 2}

// Usages outside the grid get no column count, so they keep the plain mobile/desktop split.
const STANDALONE_SLIDES = {MOBILE: 2, DESKTOP: 4}

const ComponentRecommender = ({extendedTrackingData, gridColumns, recommendedAds, title: carouselTitle, pageName}) => {
  const [trackingData, setTrackingData] = useState()

  const {domain, i18n} = useContext(SUIContext)
  const {track} = useAnalyticsTrack()
  const [isRelatedAdsCarouselOnScreen, relatedAdsCarouselRef] = useOnScreen()

  const {culture} = i18n

  const config = domain.get('config')
  const isMobile = config.get('isMobile')

  const {TRACKING_EVENT_NAMES} = config.get('tracking')

  const {RECOMMENDED_ADS} = config.get('COMMON')
  const recommendedAdsConfig = RECOMMENDED_ADS.adsList

  const {TRACKING_TRANSLATIONS_BY_CULTURE} = config.get('tracking')

  const {ADS_LIST_RECOMMENDED_ADS_CAROUSEL_FROM_AD_AD_VIEW_LIST_TYPE} = TRACKING_TRANSLATIONS_BY_CULTURE[culture]

  const isHigherThanMobileResolution = useMediaQuery(useMediaQueryBreakpoints.sm, {
    defaultMatches: !isMobile
  })

  const numberOfSlides =
    SLIDES_BY_GRID_COLUMNS[gridColumns] ??
    (isHigherThanMobileResolution ? STANDALONE_SLIDES.DESKTOP : STANDALONE_SLIDES.MOBILE)

  useMount(async () => {
    const trackingData = await domain.get('get_advertisements_tracking_use_case').execute({
      ads: recommendedAds.map(({id, title, make, model, location, pack, price, priceRankIndicator, priceDrop}) => ({
        id,
        title,
        make,
        model,
        location,
        pack,
        price,
        priceRankIndicator,
        priceDrop
      })),
      adsTypeName: 'ad_impression',
      listType: ADS_LIST_RECOMMENDED_ADS_CAROUSEL_FROM_AD_AD_VIEW_LIST_TYPE
    })
    setTrackingData(trackingData)
  })

  useEffect(() => {
    if (isRelatedAdsCarouselOnScreen) {
      track({
        event: TRACKING_EVENT_NAMES.AD_IMPRESSIONS_COLLECTED_EVENT,
        data: {
          ...trackingData,
          filtersString: extendedTrackingData.filters,
          list_order: extendedTrackingData.order
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [extendedTrackingData.filters, isRelatedAdsCarouselOnScreen, trackingData])

  return (
    <div ref={relatedAdsCarouselRef}>
      <ListRelatedAds
        ads={recommendedAds}
        display={listRelatedAdsDisplay.slides}
        itemsPerRow={recommendedAdsConfig.maxRecommendations}
        numberOfSlides={numberOfSlides}
        maxItems={10}
        extendedTrackingData={{
          ...extendedTrackingData,
          ...trackingData,
          filteredProvinces: extendedTrackingData.provinces || 'unknown'
        }}
        title={carouselTitle || i18n.t('COMMON.RELATED_FROM_AD_VISUALIZATION')}
        pageNameOrigin={TRACKING_TRANSLATIONS_BY_CULTURE[culture].ADS_LIST_PAGE_NAME}
        pageType="list"
        carouselType={ADS_LIST_RECOMMENDED_ADS_CAROUSEL_FROM_AD_AD_VIEW_LIST_TYPE}
        listType={ADS_LIST_RECOMMENDED_ADS_CAROUSEL_FROM_AD_AD_VIEW_LIST_TYPE}
      />
    </div>
  )
}

export default ComponentRecommender
